<template>
    <div class="listWrap">
        <listBrand v-if="userType==1"></listBrand>
        <listFactory v-if="userType==2"></listFactory>
        


    </div>
</template>

<script>
    import {
        mapGetters
    } from 'vuex'
    import api from '@/api/index.js'
    import request from '@/utils/request'
    import listBrand from './components/list-brand.vue'
    import listFactory from './components/list-factory.vue'
    export default {
        computed: {
            ...mapGetters([
                'userId','userType'
            ])
        },
        data() {
            return {
                
                
                
            }
        },
        components:{
            listBrand,listFactory
        },
        watch: {
        },
        created() {
        },
        methods: {

        }
    }
</script>

<style scoped="scoped" lang="scss">
    
</style>
